import { CodeBase } from "./_codeBase";


/** 条件区分*/

export class ConditionDiv extends CodeBase<ConditionDiv>
{
    /** 条件区分: "01", "作業指定", ""*/
    public static readonly WORK: ConditionDiv = new ConditionDiv("01", "作業指定", "");

    /** 条件区分: "02", "機器指定" ""*/
    public static readonly EQUIPMENT: ConditionDiv = new ConditionDiv("02", "機器指定", "");

    /** 条件区分: "03", "進捗遅延", ""*/
    public static readonly DELAY: ConditionDiv = new ConditionDiv("03", "進捗遅延", "");

    /** 条件区分: "04", "承認状況", ""*/
    public static readonly APPROVAL: ConditionDiv = new ConditionDiv("04", "承認状況", "");

    /** 条件区分: "05", "カスタム指定", ""*/
    public static readonly CUSTOM: ConditionDiv = new ConditionDiv("05", "カスタム指定", "");

    /**
     * 
     * @param value
     * @param text
     */
    protected constructor(value: any, text: string, abbr?: any) {
        super(value, text, abbr);
    }

    /**
     * 
     */
    public static List(): ConditionDiv[] {
        return [
            ConditionDiv.WORK,
            ConditionDiv.EQUIPMENT,
            ConditionDiv.DELAY,
            ConditionDiv.APPROVAL,
            ConditionDiv.CUSTOM,
        ];
    }

}
